import React from 'react'

export default () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      transform="translate(1 1)"
      stroke="#454545"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M13.215 7.3c0-2.22-1.05-3.24-3.12-3.24-2.97 0-3.42 1.605-3.435 2.985h1.215c.015-1.14.465-1.905 2.22-1.905 1.56 0 1.89.9 1.89 2.16 0 .78-.42 1.275-.975 1.755-1.095.945-2.055 1.53-2.055 3.225v1.125h1.215V12.28c0-1.14.735-1.68 1.53-2.325.765-.615 1.515-1.29 1.515-2.655zm-2.955 8.58v-1.155c0-.135-.015-.15-.12-.15H8.955c-.105 0-.105.015-.105.15v1.155c0 .06-.015.105 0 .12s.09 0 .105 0h1.185c.015 0 .09.015.105 0s.015-.06.015-.12z"
        fill="#454545"
        fillRule="evenodd"
        stroke="none"
      />
      <rect width="20" height="20" rx="2" />
    </g>
  </svg>
)
/*

<svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 46.1 (44463) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="icon/help_normal-copy" transform="translate(-1.000000, -1.000000)" fill-rule="nonzero" fill="#454545">
            <path d="M4,2.5 C3.17157288,2.5 2.5,3.17157288 2.5,4 L2.5,20 C2.5,20.8284271 3.17157288,21.5 4,21.5 L20,21.5 C20.8284271,21.5 21.5,20.8284271 21.5,20 L21.5,4 C21.5,3.17157288 20.8284271,2.5 20,2.5 L4,2.5 Z M4,1.5 L20,1.5 C21.3807119,1.5 22.5,2.61928813 22.5,4 L22.5,20 C22.5,21.3807119 21.3807119,22.5 20,22.5 L4,22.5 C2.61928813,22.5 1.5,21.3807119 1.5,20 L1.5,4 C1.5,2.61928813 2.61928813,1.5 4,1.5 Z" id="Rectangle"></path>
        </g>
    </g>
</svg>*/



// WEBPACK FOOTER //
// ./src/icons/helpIcon.js